import { render, staticRenderFns } from "./ProfilesList.vue?vue&type=template&id=2636412a&scoped=true"
import script from "./ProfilesList.vue?vue&type=script&lang=js"
export * from "./ProfilesList.vue?vue&type=script&lang=js"
import style0 from "./ProfilesList.vue?vue&type=style&index=0&id=2636412a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2636412a",
  null
  
)

export default component.exports